import * as React from 'react'
import {Util} from 'yougile-util'
import {Lang} from 'yougile-lang'

export interface ItemProps {
  title: string
  type: string
  text: string
  isNew: boolean
  time: string
  onClick(): void
}

const Item = (props: ItemProps) => {
  const bem = Util.bemFrom('notification-center', 'item')
  return (
    <div className={bem({new: props.isNew})} onClick={props.onClick}>
      <div className={bem('icon', {[props.type]: true})} />
      <div className={bem('title')}>{props.title}</div>
      <div className={bem('text')}>{props.text}</div>
      <div className={bem('alert')} />
      <div className={bem('time')}>{props.time}</div>
    </div>
  )
}

const EmptyItem = () => {
  const bem = Util.bemFrom('notification-center', 'item', 'empty')
  return <div className={bem()}>{Lang.msg.noNotifications}</div>
}

export const Items = (props: {list: Array<ItemProps & {key: string}>}) => {
  if (!props.list || props.list.length === 0) {
    return <EmptyItem />
  }
  const items = props.list.map(item => <Item {...item} key={item.key} />)
  return <>{items}</>
}
